// extracted by mini-css-extract-plugin
export default {"container":"layout_container__76NxH","content":"layout_content__V+pDe"};